// NotFound.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f9fafb;
  color: #333;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 6rem;
  margin: 0;
  color: #ff4d4d;
`;

const Subtitle = styled.h2`
  font-size: 2rem;
  margin: 0.5rem 0;
`;

const Message = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 1.5rem;
`;

const Button = styled.button`
  background-color: #4f46e5;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background-color: #3730a3;
  }
`;

const NotFound = () => {
    const navigate = useNavigate()
    const handleBackHome = () => {
        navigate("/");
    };

    return (
        <Wrapper>
            <Title>404</Title>
            <Subtitle>Page Not Found</Subtitle>
            <Message>The page you’re looking for doesn’t exist.</Message>
            <Button onClick={handleBackHome}>Go Back Home</Button>
        </Wrapper>
    );
};

export default NotFound;
